import { CircularProgress, Stack } from '@mui/material';
import { Suspense, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { setView } from '/@/store/nav/actions';
import { parseParams, parseQuerystring } from '/@/utils/router';
import { pushToGTMGA } from '../../store/tracking/utils';

export default function ViewContext(props) {
    const dispatch = useDispatch();
    const location = useLocation();
    const params = useParams();

    const trackPageView = (props) => {
        if (props.viewsByName[props.name].noPageViewTracking) return;

        const { pathname, search } = props.location;

        const event = {
            action: 'page_view',
            page_path: pathname + search,
            page_location: window.location.href,
        };

        pushToGTMGA(event);
    };
    useEffect(() => {
        dispatch(setView({ name: props.name, type: props.type }));
    }, []);

    useEffect(() => {
        trackPageView(props);
    }, [location.pathname, location.search]);

    const { viewProps, component: ViewComponent } = props;
    // TO-DO: This props should be forwarded inside a container variable
    // so they are easier to reason about in child containers and also to avoid
    // overwrites.

    const querystring = useMemo(() => parseQuerystring(location.search), [location.search]);
    const parsedParams = useMemo(() => parseParams(params), [params]);
    return (
        <Suspense
            fallback={
                <Stack sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </Stack>
            }
        >
            <ViewComponent location={location} {...viewProps} {...querystring} {...parsedParams} />
        </Suspense>
    );
}
